import React from 'react';
import ButtonGlynt from '../../common/Buttons/ButtonGlynt';
import StatusEditDialog from '../StatusEditDialog';
import { useDocumentDataList } from '../../hooks/documentData/useDocumentDataList';
import { DocumentDataStatusFilters } from '../../../types/packager-types';

interface ISetDocumentDataStatusProps {
  documentId: string;
  documentDataId: string | null;
  currentStatus: DocumentDataStatusFilters | null;
  currentExclusionReason?: string | null;
  currentEscalationDetail?: string | null;
}

const SetDocumentDataStatus: React.FC<ISetDocumentDataStatusProps> = ({
  documentId,
  documentDataId,
  currentStatus,
  currentExclusionReason,
  currentEscalationDetail,
}) => {
  const [open, setOpen] = React.useState(false);

  // Resolve a doc data id lazily when the row didn't come with one (e.g. older list responses).
  const { data: documentDataList } = useDocumentDataList({
    documentId,
    enabled: open && !documentDataId,
  });
  const effectiveDocumentDataId = documentDataId || documentDataList?.results?.[0]?.id || null;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <ButtonGlynt
          variant="outlined"
          size="xs"
          data-cy="btn-set-document-data-status"
          onClick={() => setOpen(true)}
          sx={{ marginTop: '5px' }}
        >
          Edit
        </ButtonGlynt>
      </div>
      <StatusEditDialog
        open={open}
        onClose={() => setOpen(false)}
        documentId={documentId}
        documentDataId={effectiveDocumentDataId}
        currentDocumentDataStatus={currentStatus}
        currentExclusionReason={currentExclusionReason}
        currentEscalationDetail={currentEscalationDetail}
      />
    </>
  );
};

export default SetDocumentDataStatus;
